var _effectorFileName = "/src/page-content/home/components/partners/constants.ts";
import type { ComponentType } from 'react';
import OZONIcon from '@/shared/components/icons/ozon-icon';
import { cn } from '@/shared/lib/cn';
export type PartnerCard = {
  type: 'partner';
  partnerName: string;
  link: string;
  text: string;
  Icon: ComponentType<{
    className?: string;
  }>;
} | {
  type: 'review';
  title?: string;
  subtitle: string;
  text: string;
};
export const CARD_CLASS_NAME = cn('group relative mx-auto flex w-full max-w-[400px] md:max-w-full flex-col overflow-hidden rounded-xl px-4 py-6 pb-8 sm:px-10 sm:py-10', 'bg-white [box-shadow:0_0_0_1px_rgba(0,0,0,.03),0_2px_4px_rgba(0,0,0,.05),0_12px_24px_rgba(0,0,0,.05)]', 'transform-gpu dark:bg-black dark:[border:1px_solid_rgba(255,255,255,.1)] dark:[box-shadow:0_-20px_80px_-20px_#ffffff1f_inset]');
export const PARTNERS: PartnerCard[] = [{
  type: 'partner' as const,
  partnerName: 'Ozon',
  link: 'https://www.ozon.ru/',
  text: `Ozon is&nbsp;one of&nbsp;the biggest marketplaces in&nbsp;the&nbsp;CIS. We&nbsp;teach English
              to&nbsp;company management and create personalized learning plans for each group to&nbsp;clearly
              demonstrate how English can enhance team communication and efficiency. In&nbsp;just 4&nbsp;months, all
              groups have reached a&nbsp;new level of&nbsp;language, confidently conduct negotiations, and present
              projects on&nbsp;the international stage.`,
  Icon: OZONIcon
}, {
  type: 'review' as const,
  subtitle: 'HR Business Partner, fintech company, Serbia',
  text: `Our company works with partners in different countries, so effective communication in English is essential for our employees.
Enlerno helped our employees improve confidence in meetings and discuss product topics more clearly. Huge advantage is that the lessons were based on our real work situations.
We especially appreciated how Enlerno teachers were able to adapt the lessons for employees living in different countries, time zones, and cultural environments.`
}, {
  type: 'review' as const,
  subtitle: 'HR, e-commerce, Kazakhstan',
  text: `Thank you for this course! The training helped our marketing team communicate more confidently in English during meetings and negotiations with international partners. It is great that during the lessons we focused only on the topics that are relevant for our industry. We also liked the flexible schedule. Our employees live in different time zones, so we really appreciated that your team organized the groups and scheduled the classes independently without requiring additional coordination from our HR team.`
}, {
  type: 'review' as const,
  subtitle: 'HR Manager, fintech, Georgia',
  text: `We partnered with Enlerno to provide our employees with discounted access to English lessons. The promo code system makes it easy for employees to join classes individually without additional administration from our side. Many employees have already started learning, and some even shared the offer with their family members.`
}];